export default __webpack_public_path__ + "static/media/star.8fe9818f.svg";